import { useTranslations } from "@/lib/static-intl";
import AddPlaceButton from "../add-place-button";

const ListEndMessage = ({ openPlaceAddModal }) => {
  const t = useTranslations("places");
  return (
    <div className="pt-6 pb-20 lg:pb-14 text-black/40 dark:text-white/40 text-xs flex flex-col items-center justify-center gap-6">
      {t("end of list")}
      <AddPlaceButton openPlaceAddModal={openPlaceAddModal} />
    </div>
  );
};

export default ListEndMessage;
